import { MappedClass, MappedProperty } from '@h5s/util-object';
import { ZPrinterTransactionType } from './z-printer-transaction-type';
import { ZPrinterDocumentType } from './z-printer-document-type';
import { Document, PrintTransactionItem, ProtocolResponse } from '@h5s/dtos-api';

@MappedClass()
export class ZPrinterTransaction {
  @MappedProperty()
  cancelled?: boolean;

  @MappedProperty()
  created_at?: string;

  @MappedProperty()
  created_by?: string;

  @MappedProperty()
  deleted_at?: string;

  @MappedProperty()
  deleted_by?: string;

  // Questa property non è mappata perché usata solamente per logging, se servirà fare delle operazioni, sarà da mappare con una nostra entity
  @MappedProperty()
  document?: Document;

  @MappedProperty()
  document_closure?: number;

  @MappedProperty()
  document_number?: number;

  @MappedProperty()
  electronic_receipt_email?: string;

  @MappedProperty()
  electronic_receipt_path?: string;

  @MappedProperty()
  failed?: boolean;

  @MappedProperty()
  fiscal?: boolean;

  // Questa property non è mappata perché usata solamente per logging, se servirà fare delle operazioni, sarà da mappare con una nostra entity
  @MappedProperty()
  fiscal_protocol_response?: Array<ProtocolResponse>;

  @MappedProperty()
  id?: string;

  @MappedProperty()
  is_deleted?: boolean;

  @MappedProperty()
  is_electronic_receipt?: boolean;

  @MappedProperty()
  last_modified_at?: string;

  @MappedProperty()
  last_modified_by?: string;

  @MappedProperty()
  paid?: number;

  @MappedProperty()
  payments_covers_amount?: boolean;

  @MappedProperty()
  price_variation_total?: number;

  @MappedProperty()
  printed?: boolean;

  @MappedProperty()
  printer_id?: string;

  @MappedProperty()
  row_version?: number;

  @MappedProperty()
  sub_total?: number;

  @MappedProperty()
  total?: number;

  // Questa property non è mappata perché usata solamente per logging, se servirà fare delle operazioni, sarà da mappare con una nostra entity
  @MappedProperty()
  transaction_items?: Array<PrintTransactionItem>;

  @MappedProperty()
  transaction_state?: ZPrinterTransactionType;

  @MappedProperty()
  transaction_type?: ZPrinterDocumentType;
}
